
import { useTranslation } from 'react-i18next';
import { useScrollAnimation } from '../../../hooks/useScrollAnimation';
import Button from '../../../components/base/Button';

export default function DonateSection() {
  const { t } = useTranslation();
  const { ref, isVisible } = useScrollAnimation();

  return (
    <section 
      id="donate" 
      ref={ref}
      className={`py-12 sm:py-16 md:py-24 relative transition-all duration-1000 ${
        isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
      }`}
      style={{
        backgroundImage: 'url(https://public.readdy.ai/ai/img_res/02a448aee3603d1b97a703091bd7436a.jpg)',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat'
      }}
    >
      <div className="absolute inset-0 bg-black/60"></div>
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center relative z-10">
        <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-white tracking-tight mb-3 sm:mb-4 sm:mb-6 px-2">
          {t('donate.title')}
        </h2>
        <p className="text-sm sm:text-base lg:text-lg text-white/90 mb-6 sm:mb-8 md:mb-12 max-w-3xl mx-auto leading-relaxed px-4">
          {t('donate.subtitle')}
        </p>
        
        <div className="flex flex-col gap-3 sm:gap-4 justify-center max-w-2xl mx-auto px-4 sm:px-0 sm:flex-row">
          <Button variant="outline" size="lg" className="w-full sm:w-auto whitespace-nowrap text-sm sm:text-base bg-white/10 border-white/30 text-white hover:bg-white/20 hover:border-white/50">
            <div className="w-4 h-4 sm:w-5 sm:h-5 flex items-center justify-center mr-2">
              <i className="ri-paypal-line"></i>
            </div>
            {t('donate.paypal')}
          </Button>
          <Button variant="outline" size="lg" className="w-full sm:w-auto whitespace-nowrap text-sm sm:text-base bg-white/10 border-white/30 text-white hover:bg-white/20 hover:border-white/50">
            <div className="w-4 h-4 sm:w-5 sm:h-5 flex items-center justify-center mr-2">
              <i className="ri-bank-card-line"></i>
            </div>
            {t('donate.stripe')}
          </Button>
          <Button variant="outline" size="lg" className="w-full sm:w-auto whitespace-nowrap text-sm sm:text-base bg-white/10 border-white/30 text-white hover:bg-white/20 hover:border-white/50">
            <div className="w-4 h-4 sm:w-5 sm:h-5 flex items-center justify-center mr-2">
              <i className="ri-smartphone-line"></i>
            </div>
            {t('donate.zelle')}
          </Button>
        </div>
      </div>
    </section>
  );
}
